import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useOrderAuth } from "./OrderAuthContext";
import orderData from "../Datas/orderData";
import productData from "../Datas/productData";
import "../css/orders.scss";

const SELLER_NAME = "mvandora";
const SELLER_DOMAIN = "mvandora.store";

function formatDate(value) {
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(`${value}T00:00:00`));
}

function formatMoney(amount, currency) {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

function orderReference(order) {
  const date = order.createdAt.replaceAll("-", "");
  const number = order.id.replace("order-", "");
  return `ORD-${date}-${number}`;
}

function Orders() {
  const navigate = useNavigate();
  const { logout } = useOrderAuth();

  const handleLogout = () => {
    logout();
    navigate("/order-login", { replace: true });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="orders-page">
      <Header />
      <main className="orders-overview" id="MainContent">
        <header className="orders-overview__hero">
          <div>
            <p className="orders-page__eyebrow">Account overview</p>
            <h1>Your orders</h1>
          </div>
          <div className="orders-overview__intro">
            <p>Review order information, delivery details and tracking status.</p>
            <button type="button" onClick={handleLogout}>
              Sign out
            </button>
          </div>
        </header>

        <section className="orders-ledger" aria-label="Order list">
          <div className="orders-ledger__head" aria-hidden="true">
            <span>Order</span>
            <span>Product</span>
            <span>Seller store</span>
            <span>Date</span>
            <span>Status</span>
            <span>Unit price</span>
            <span>Total</span>
            <span />
          </div>

          {orderData.map((order) => {
            const product = productData.find(
              (item) => item.id === order.productId
            );
            const unitPrice = order.totalAmount / order.quantity;

            return (
              <article className="orders-ledger__row" key={order.id}>
                <div className="orders-ledger__order" data-label="Order">
                  <strong>{orderReference(order)}</strong>
                  <span>Placed by {order.buyerName}</span>
                </div>

                <div className="orders-ledger__product" data-label="Product">
                  {product ? (
                    <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                      decoding="async"
                    />
                  ) : null}
                  <div>
                    <strong>{product?.name || order.productName}</strong>
                    <span>
                      {order.quantity} {order.quantity === 1 ? "pair" : "pairs"}
                    </span>
                  </div>
                </div>

                <div className="orders-ledger__seller" data-label="Seller store">
                  <strong>{SELLER_NAME}</strong>
                  <span>{SELLER_DOMAIN}</span>
                </div>

                <div className="orders-ledger__date" data-label="Date">
                  {formatDate(order.createdAt)}
                </div>

                <div data-label="Status">
                  <span className="orders-ledger__status">
                    <svg viewBox="0 0 20 20" aria-hidden="true">
                      <circle cx="10" cy="10" r="7.5" />
                      <path d="m6.5 10 2.2 2.2 4.8-5" />
                    </svg>
                    Delivered
                  </span>
                </div>

                <div className="orders-ledger__price" data-label="Unit price">
                  {formatMoney(unitPrice, order.currency)}
                </div>

                <div className="orders-ledger__total" data-label="Total">
                  {formatMoney(order.totalAmount, order.currency)}
                </div>

                <Link
                  className="orders-ledger__view"
                  to={`/orders/${order.id}`}
                  aria-label={`View ${orderReference(order)}`}
                >
                  View order <span aria-hidden="true">→</span>
                </Link>
              </article>
            );
          })}
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Orders;
